<div class="modal-overlay" *ngIf="show" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{ 'auth.forgotPassword.title' | transloco }}</h2>
      <button type="button" class="close-btn" [attr.aria-label]="'common.actions.close' | transloco" (click)="onClose()">
        <lucide-icon class="custom-icon" name="X"></lucide-icon>
      </button>
    </div>

    <p class="modal-description">
      {{ 'auth.forgotPassword.description' | transloco }}
    </p>

    <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
      <div class="form-field">
        <app-input
          [placeholder]="'auth.placeholders.email' | transloco"
          [icon]="'envelope'"
          [size]="'large'"
          formControlName="email"
          [error]="!!forgotForm.get('email')?.invalid && !!forgotForm.get('email')?.touched"
          [errorMessage]="getErrorMessage('email')"
        ></app-input>
      </div>

      <app-button
        [label]="'auth.forgotPassword.submit' | transloco"
        (click)="onSubmit()"
        class="full-width-button"
      ></app-button>
    </form>

    <app-button
      [label]="'auth.forgotPassword.backToLogin' | transloco"
      (onClick)="onClose()"
      variant="link"
      size="large"
      class="bottom-link"
    />
  </div>
</div>